<template lang="pug">
  .headline
    a(:href="mailTo" target="_blank" )
      span.theEmail.pb-1 Email
</template>

<script>
export default {
  props: ['email'],
  computed: {
    mailTo() {
      return 'mailto:' + this.email;
    }
  }
};
</script>

<style lang="stylus" scoped>
.headline a
  text-decoration none

.theEmail
  border-bottom 1px solid #000000
  color var(--v-primary-darken2)

.theEmail:hover
  border-bottom 1px solid rgba(0, 0, 0, 0)
  color var(--v-info-darken2)
</style>
